export const SIDEBAR_COLLAPSED_CLASS = "sidebar-collapsed"
export const SIDEBAR_COLLAPSED_STORAGE_KEY = "appsignal.sidebarCollapsed"

export const isSidebarCollapsed = () => {
  try {
    return window.sessionStorage.getItem(SIDEBAR_COLLAPSED_STORAGE_KEY) === "true"
  } catch {
    return false
  }
}

export const applySidebarCollapsedState = (collapsed) => {
  document.documentElement.classList.toggle(SIDEBAR_COLLAPSED_CLASS, collapsed)

  document.querySelectorAll(".js-sidebar-collapse-toggle").forEach((toggle) => {
    toggle.setAttribute("aria-expanded", collapsed ? "false" : "true")
    toggle.setAttribute("aria-label", collapsed ? "Show menu" : "Hide menu")
  })
}

export const setSidebarCollapsed = (collapsed) => {
  try {
    if (collapsed) {
      window.sessionStorage.setItem(SIDEBAR_COLLAPSED_STORAGE_KEY, "true")
    } else {
      window.sessionStorage.removeItem(SIDEBAR_COLLAPSED_STORAGE_KEY)
    }
  } catch {
    // Keep the UI usable when sessionStorage is unavailable.
  }

  applySidebarCollapsedState(collapsed)
}

export const toggleSidebarCollapsed = () => {
  const collapsed = !isSidebarCollapsed()

  setSidebarCollapsed(collapsed)

  return collapsed
}

export const initializeSidebarCollapsedState = () => {
  applySidebarCollapsedState(isSidebarCollapsed())
}
